import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    CREATE_REVIEWER,
    CREATE_REVIEW_PANEL,
    DELETE_REVIEWER,
    DELETE_REVIEW_PANEL,
    EDIT_REVIEWER,
    EDIT_REVIEW_PANEL,
    SET_REVIEWER,
    GET_REVIEWER_LIST,
} from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';

import API from 'api/call';
import { safeSaga } from 'store';

const initialState = {
    reviewerList: [
    ],
    reviewerTotal: 0,
    reviewPanelList: [
    ],
};

const getMaxId = (list, key) => {
    const ids = list.map((item) => item.id);
    ids.sort((a, b) => b - a);
    return ids[0];
};

function* getReviewerList(action) {
    const { params, callback } = action.payload;
    const { reviewer } = yield select();
    
    try {
        const result = yield call(API.reviewer.getReviewerList, { params });
        const res = result.data.result;
        reviewer.reviewerList = res.data;
        reviewer.reviewerTotal = res.total;

        yield put({
            type: SET_REVIEWER,
            payload: reviewer,
        });

        callback?.();
    } catch (error) {
        console.log('create reviewer failed:', error);
    };
}

function* createReviewer(action) {
    const { data, callback } = action.payload;
    setGlobalLoading(true);
    try {
        yield call(API.reviewer.addReviewerAccount, data);
        callback?.();
    } catch(error) {
        console.log('create reviewer failed:', error);
    };
    setGlobalLoading(false);
}

function* editReviewer(action) {
    const { data, callback } = action.payload;
    setGlobalLoading(true);
    try {
        yield call(API.reviewer.updateReviewerAccount, data);

        callback?.();
    } catch (error) {
        console.log('edit reviewer failed:', error);
    };
    setGlobalLoading(false);
}

function* deleteReviewer(action) {
    const { id, callback } = action.payload;
    setGlobalLoading(true);
    try {
        yield call(API.reviewer.deleteReviewerAccount, { id: id });

        callback?.();
    } catch (error) {
        console.log('delete reviewer failed:', error);
    };
    setGlobalLoading(false);
}

function* createReviewPanel(action) {
    const row = action.payload;
    const { reviewer } = yield select();
    const index = (Number(getMaxId(reviewer.reviewPanelList, 'id')) + 1).toString();
    reviewer.reviewPanelList.unshift({ ...row, id: index ? index : '0' });
    yield put({
        type: SET_REVIEWER,
        payload: reviewer,
    });
}

function* editReviewPanel(action) {
    const row = action.payload;
    const { reviewer } = yield select();

    let list = reviewer.reviewPanelList;
    const index = list.findIndex((i) => i.id === row.id);
    reviewer.reviewPanelList[index] = { ...row };

    yield put({
        type: SET_REVIEWER,
        payload: reviewer,
    });
}

function* deleteReviewPanel(action) {
    const row = action.payload;
    const { reviewer } = yield select();
    let list = reviewer.reviewPanelList;
    const index = list.findIndex((i) => i.id === row.id);
    reviewer.reviewPanelList.splice(index, 1);
    yield put({
        type: SET_REVIEWER,
        payload: reviewer,
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REVIEWER:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchReviewer() {
    yield takeEvery(GET_REVIEWER_LIST, safeSaga(getReviewerList));
    yield takeEvery(CREATE_REVIEWER, safeSaga(createReviewer));
    yield takeEvery(EDIT_REVIEWER, safeSaga(editReviewer));
    yield takeEvery(DELETE_REVIEWER, safeSaga(deleteReviewer));
    yield takeEvery(CREATE_REVIEW_PANEL, safeSaga(createReviewPanel));
    yield takeEvery(EDIT_REVIEW_PANEL, safeSaga(editReviewPanel));
    yield takeEvery(DELETE_REVIEW_PANEL, safeSaga(deleteReviewPanel));
}

export default reducer;
